import { createClient } from 'next-sanity';
import { createImageUrlBuilder } from '@sanity/image-url';

export const client = createClient({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || '',
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || 'production',
  apiVersion: '2024-03-20', // use current date (YYYY-MM-DD) to target the latest API version
  useCdn: false, // set to `false` for ISR or static generation
});

const builder = createImageUrlBuilder(client);

export function urlFor(source: any) {
  return builder.image(source);
}

// Helper function to fetch data
export async function sanityFetch<QueryResponse>({
  query,
  params = {},
  revalidate = 3600, // default revalidate every hour
  tags = [],
}: {
  query: string;
  params?: any;
  revalidate?: number | false;
  tags?: string[];
}) {
  return client.fetch<QueryResponse>(query, params, {
    next: {
      revalidate,
      tags,
    },
  });
}
export async function getPostsBySlugs(slugs: string[]) {
  const query = `*[_type == "post" && slug.current in $slugs] {
    title,
    "slug": slug.current,
    excerpt,
    featuredImage,
    category->{title, "slug": slug.current},
    publishedAt,
    readTime,
    featured
  }`;
  return sanityFetch<any[]>({ query, params: { slugs } });
}

export async function getPostsByCategory(category: string, limit: number = 3) {
  const query = `*[_type == "post" && category->title == $category] | order(publishedAt desc) [0...$limit] {
    title,
    "slug": slug.current,
    excerpt,
    featuredImage,
    category->{title, "slug": slug.current},
    publishedAt,
    readTime,
    featured
  }`;
  return sanityFetch<any[]>({ query, params: { category, limit } });
}
